import axios from 'axios';  
  
const apiClient = axios.create({  
  baseURL: process.env.REACT_APP_API_URL || '/api',  
  headers: {  
    'Content-Type': 'application/json',  
  },  
});  
  
// Send the signed-in user's JWT. Admin and owner endpoints require it.
apiClient.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Add a response interceptor for error handling  
apiClient.interceptors.response.use(  
  response => response,  
  error => {
    console.error('API Error:', error.response?.data || error.message);
    // An expired or revoked token: drop the session and send the user to sign in again.
    // (A failed login has no token yet, so it is not caught here.)
    if (error.response?.status === 401 && localStorage.getItem('token')) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      if (window.location.pathname !== '/login') window.location.assign('/login');
    }
    return Promise.reject(error);  
  }  
);  
  
export default apiClient;
